import type { FEATURE_FLAGS } from '@cc/common';

type FeatureFlags = keyof typeof FEATURE_FLAGS;

export const featureFlagTranslations: Record<FeatureFlags | string, string> = {
	// Authentication & Registration
	FEATURE_LOGIN: 'Login',
	FEATURE_FORGOT_PASSWORD: 'Forgot Password',
	FEATURE_REGISTER_CONVERSATION_PARTNER: 'Conversation Partner Registration',
	FEATURE_REGISTER_FRIENDSHIP_FAMILY: 'Friendship Family Registration',
	FEATURE_REGISTER_STUDENT: 'Student Registration',
	// Platform Features
	FEATURE_TASKS: 'Tasks',
	FEATURE_GROUPCHAT: 'Group Chat',
	FEATURE_CLASSMATES: 'Classmates',
	FEATURE_IEP: 'IEP',
	FEATURE_CONVERSATION_PARTNER: 'Language Exchange',
	FEATURE_UNDERGRADUATE_STUDENT: 'Undergraduate Students',
	FEATURE_GRADUATE_STUDENT: 'Graduate Students',

	FEATURE_FRIENDSHIP_FAMILY: 'Friendship Families',
	FEATURE_QUICK_LINKS: 'Quick Links',
	FEATURE_SEARCHING_FOR: 'Searching For',
	FEATURE_EVENTS: 'Events',
	FEATURE_CHAT: 'Conversations',
	FEATURE_PROFILE_STUDENT: 'Student Profiles',
	FEATURE_PROFILE_CONVERSATION_PARTNER: 'Conversation Partner Profiles',
	FEATURE_PROFILE_FRIENDSHIP_FAMILY: 'Friendship Family Profiles',
	FEATURE_SETTING: 'Settings',
	FEATURE_STAFF_IN_NAVIGATION: 'Discover your administrators',
	FEATURE_FACULTY_IN_NAVIGATION: 'Discover your faculty members',
	FEATURE_MICRO_COMMUNITIES: 'Explore Micro Communities',
	// Admin Features
	FEATURE_ADMIN_BROADCAST: 'Admin - Broadcast',
	FEATURE_ADMIN_INTERESTS: 'Admin - Interests',
	FEATURE_ADMIN_GROUPS: 'Admin - Groups',
	FEATURE_ADMIN_CONTENT_MODERATION: 'Admin - Content'
};

export const FEATURE_FLAGS_MAP = {
	FEATURE_ADMIN_BROADCAST: {
		title: 'Broadcast Message',
		description: 'Allows admins to send broadcast messages to all users.'
	},
	FEATURE_ADMIN_CONTENT_MODERATION: {
		title: 'Content Moderation',
		description: 'Enables admins to moderate user-generated content for compliance with platform standards.'
	},
	FEATURE_ADMIN_GROUPS: {
		title: 'Groups',
		description: 'Provides admins with the ability to create, manage, and delete user groups.'
	},
	FEATURE_ADMIN_MAJORS: {
		title: 'Manage Majors',
		description: 'Allows admins to manage and edit major fields of study in the platform.'
	},
	FEATURE_CHAT: {
		title: 'Chat Functionality',
		description: 'Enables chat functionality for students, prospective students, and admins.'
	},
	FEATURE_QUICK_LINKS: {
		title: 'Quick Links Functionality',
		description: 'Provides quick access to important links and resources within the platform.'
	},
	FEATURE_EVENTS: {
		title: 'Events Functionality',
		description: 'Enables the creation, management, and participation in events.'
	},
	FEATURE_TASKS: {
		title: 'Tasks Functionality',
		description: 'Task management functionality for users to organize and track their activities.'
	},
	FEATURE_MICRO_COMMUNITIES: {
		title: 'Micro Communities Functionality',
		description: 'Will make micro-communities available within the platform.'
	},
	FEATURE_GROUPCHAT: {
		title: 'Forum Functionality',
		description: 'Forum functionality to enable themed discussions and information sharing.'
	},
	FEATURE_CLASSMATES: {
		title: 'Classmates Directory in Sidebar',
		description: 'Provides a directory of classmates in the sidebar for easy access.'
	},
	FEATURE_ALUMNI: {
		title: 'Alumni Directory in Sidebar',
		description: 'Includes an alumni directory in the sidebar and supports alumni role badge.'
	},
	FEATURE_AMBASSADOR_IN_NAVIGATION: {
		title: 'Ambassador Directory in Sidebar',
		description: 'Features an ambassador directory in the sidebar to connect with student representatives.'
	},
	FEATURE_STAFF_IN_NAVIGATION: {
		title: 'Staff Directory in Sidebar',
		description: 'Adds a staff item in the sidebar'
	},
	FEATURE_FACULTY_IN_NAVIGATION: {
		title: 'Faculty Directory in Sidebar',
		description: 'Adds a faculty item in the sidebar'
	},
	FEATURE_GRADUATE_STUDENT: {
		title: 'Graduate Student Role Support',
		description: 'Adds support for role badge.'
	},
	FEATURE_UNDERGRADUATE_STUDENT: {
		title: 'Undergraduate Student Role Support',
		description: 'Adds support for role badge.'
	},
	FEATURE_IEP: {
		title: 'IEP Student Role Support',
		description: 'Adds support for role badge.'
	},
	FEATURE_FRIENDSHIP_FAMILY: {
		title: 'Friendship Family Functionality',
		description: 'Functionality to support the Friendship Family program, connecting students with local families.'
	},
	FEATURE_CONVERSATION_PARTNER: {
		title: 'Conversation Partner Functionality',
		description: 'Enables the Conversation Partner functionality, fostering language learning and cultural exchange.'
	},
	MODULE_PROSPECTIVE_STUDENT: {
		title: 'Prospective Student Functionality',
		description: 'Enables the Prospective Student module, allowing prospective students to connect with ambassadors.'
	}
};
